import _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import { InputFilter } from '../../components/Inputs/InputFilter';
import SelectInput from '../../components/Inputs/SelectInput';
import ChangeStatusModal from '../../components/Modals/ChangeStatusModal';
import Datatable from '../../components/table/Datatable';
import { objectsConstants } from '../../constants/objects.constants';
import { tableHelper } from '../../helpers/tableHelper';
import { pedidosService } from '../../services/pedidos.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import './Dashboard.css';
const endPointView = '/pedidos/edit/';
const columns = [
  {
    path: 'status',
    title: 'Situação',
    isStatus: true,
  },
  {
    path: 'numeroPedido',
    title: 'Número do pedido',
    isKey: true,
    dataSort: false,
    className: 'txtBold',
  },
  {
    path: 'cliente.label',
    title: 'Cliente',
    isKey: false,
    dataSort: false,
  },
  {
    path: 'statusAlcis',
    title: 'Status WMS',
    isKey: false,
    dataSort: false,
  },
  {
    path: 'numeroPedidoCliente',
    title: 'Nº Pedido Cliente',
    isKey: false,
    dataSort: false,
  },
  {
    path: 'dataHoraColeta',
    title: 'Data e Hora da Expedição',
    isKey: false,
    isDateTime: true,
    dataSort: false,
  },
  {
    path: 'concluido',
    title: 'Concluido',
    isKey: false,
    yesNo: true,
    dataSort: false,
  },
];

class Dashboard extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    this.state = { pedidos: [], showModal: false };
  }

  atualizaDash = () => {
    pedidosService.findAll().then((r) => {
      this.setState({ pedidos: r.data });
    });
    if (this.refTable) {
      this.refTable.getWrappedInstance().updateTable();
    }
  };

  componentDidMount() {
    this.interval = setInterval(this.atualizaDash, 10000);
    pedidosService.findAll().then((r) => {
      this.setState({ pedidos: r.data });
    });
  }

  getStatusColumn = (row, column) => {
    if (row.status == 'CRIADO') {
      return (
        <div>
          <span className={'bullet criado'}></span>
        </div>
      );
    }
    if (row.status == 'SEPARACAO_ATRASADA') {
      return (
        <div>
          <span className={'bullet atrasado'}></span>
        </div>
      );
    }
    if (row.status == 'FATURAMENTO_ATRASADO') {
      return (
        <div>
          <span className={'bullet atrasado-faturamento'}></span>
        </div>
      );
    }
    if (row.status == 'EM_SEPARACAO') {
      return (
        <div>
          <span className={'bullet em-separacao'}></span>
        </div>
      );
    }
    if (row.status == 'A_FATURAR') {
      return (
        <div>
          <span className={'bullet a-faturar'}></span>
        </div>
      );
    }
    if (row.status == 'FATURADO') {
      return (
        <div>
          <span className={'bullet faturado'}></span>
        </div>
      );
    }
  };
  customRender = (row, extra, column) => {
    let value = _.get(extra, column.path);
    if (column.isStatus) {
      return this.getStatusColumn(extra, column);
    }

    return tableHelper.renderCustom(row, extra, column);
  };

  toogle = (pedido) => {
    this.setState({ showModal: !this.state.showModal, pedido });
  };
  getListPedidoStatus = (status) => {
    return _.filter(this.state.pedidos, { status });
  };
  getUltimoPedidoPorStatus = (pedidosPorStatus) => {
    return _.maxBy(pedidosPorStatus, 'ultimaAtualizacao'); // Supondo que 'dataAlteracao' é o nome do campo que contém a data de alteração.
  };
  formatDate = (timestamp) => {
    return moment(timestamp).format('DD/MM/YYYY HH:mm:ss');
  };
  openPedido = (id) => {
    this.props.history.push(endPointView + id);
  };
  render() {
    const { pedidos } = this.state;
    let fields = _.map(columns, function(coluna) {
      return coluna.path;
    });
    const pedidosCriados = _.filter(pedidos, (p) => {
      return p.status == 'CRIADO';
    });
    const pedidosSeparacaoAtrasada = _.filter(pedidos, (p) => {
      return p.status == 'SEPARACAO_ATRASADA';
    });
    const pedidosFaturamentoAtrasado = _.filter(pedidos, (p) => {
      return p.status == 'FATURAMENTO_ATRASADO';
    });
    const pedidosEmSeparacao = _.filter(pedidos, (p) => {
      return p.status == 'EM_SEPARACAO';
    });
    const pedidosAguardandoFaturamento = _.filter(pedidos, (p) => {
      return p.status == 'A_FATURAR';
    });
    const pedidosFaturados = _.filter(pedidos, (p) => {
      return p.status == 'FATURADO';
    });
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={this.customRender}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
      >
        {column.title}
      </TableHeaderColumn>
    ));
    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Painel de Situação"
          subTitle=" "
          canBack={false}
        />
        <div className={'row p-3'}>
          <ChangeStatusModal
            isModalVisible={this.state.showModal}
            toogleModal={this.toogle}
            pedido={this.state.pedido}
          />
          <div className="col-2 p-3 align-self-stretch">
            <div className="card bg-c-lightblue order-card card-concluido">
              <div className="card-block">
                <h2 className="m-b-20">PEDIDOS PRONTOS PARA EXPEDIÇÃO</h2>
                <hr />
                <h3>
                  <span>
                    {
                      pedidos.filter(
                        (p) => p.concluido && p.statusAlcis !== 'expedido'
                      ).length
                    }
                  </span>{' '}
                  PEDIDO(S)
                </h3>
                {pedidos
                  .filter((p) => p.concluido && p.statusAlcis !== 'expedido')
                  .map((pedido) => (
                    <div
                      className={'item-concluido'}
                      onClick={() => {
                        this.openPedido(pedido.id);
                      }}
                    >
                      <p className="m-b-0">Pedido: {pedido.numeroPedido}</p>
                      <p className="m-b-0">Cliente: {pedido.cliente.label}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* Card de Tamanho 9 */}
          <div className="col-10 p-3">
            <div class="row w-100 col-12">
              <div className="col">
                <div className="card bg-c-gray order-card">
                  <div className="card-block">
                    <h6 className="m-b-20 text-center">
                      {pedidosCriados.length}
                    </h6>

                    <p className="dashboard-text-status">CRIADOS</p>
                    {(() => {
                      const ultimoPedido = this.getUltimoPedidoPorStatus(
                        pedidosCriados
                      );
                      if (ultimoPedido) {
                        return (
                          <React.Fragment>
                            <p
                              style={{ fontSize: '0.7rem' }}
                              className="m-t-10"
                            >
                              Último Pedido: {ultimoPedido.numeroPedido}
                            </p>
                            <p style={{ fontSize: '0.7rem' }}>
                              Data:{' '}
                              {this.formatDate(ultimoPedido.ultimaAtualizacao)}
                            </p>
                          </React.Fragment>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card bg-c-pink order-card">
                  <div class="card-block">
                    <h6 class="m-b-20 text-center">
                      {pedidosSeparacaoAtrasada.length}
                    </h6>

                    <p class="dashboard-text-status">SEPARAÇÕES ATRASADAS</p>
                    {(() => {
                      const ultimoPedido = this.getUltimoPedidoPorStatus(
                        pedidosSeparacaoAtrasada
                      );
                      if (ultimoPedido) {
                        return (
                          <React.Fragment>
                            <p
                              style={{ fontSize: '0.7rem' }}
                              className="m-t-10"
                            >
                              Último Pedido: {ultimoPedido.numeroPedido}
                            </p>
                            <p style={{ fontSize: '0.7rem' }}>
                              Data:{' '}
                              {this.formatDate(ultimoPedido.ultimaAtualizacao)}
                            </p>
                          </React.Fragment>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card bg-c-pink-faturamento order-card">
                  <div className="card-block">
                    <h6 className="m-b-20 text-center">
                      {pedidosFaturamentoAtrasado.length}
                    </h6>

                    <p className="dashboard-text-status">
                      FATURAMENTO ATRASADO
                    </p>
                    {(() => {
                      const ultimoPedido = this.getUltimoPedidoPorStatus(
                        pedidosFaturamentoAtrasado
                      );
                      if (ultimoPedido) {
                        return (
                          <React.Fragment>
                            <p
                              style={{ fontSize: '0.7rem' }}
                              className="m-t-10"
                            >
                              Último Pedido: {ultimoPedido.numeroPedido}
                            </p>
                            <p style={{ fontSize: '0.7rem' }}>
                              Data:{' '}
                              {this.formatDate(ultimoPedido.ultimaAtualizacao)}
                            </p>
                          </React.Fragment>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card bg-c-yellow order-card">
                  <div className="card-block">
                    <h6 className="m-b-20 text-center">
                      {pedidosEmSeparacao.length}
                    </h6>
                    <p className="dashboard-text-status">EM SEPARAÇÃO</p>
                    {(() => {
                      const ultimoPedido = this.getUltimoPedidoPorStatus(
                        pedidosEmSeparacao
                      );
                      if (ultimoPedido) {
                        return (
                          <React.Fragment>
                            <p
                              style={{ fontSize: '0.7rem' }}
                              className="m-t-10"
                            >
                              Último Pedido: {ultimoPedido.numeroPedido}
                            </p>
                            <p style={{ fontSize: '0.7rem' }}>
                              Data:{' '}
                              {this.formatDate(ultimoPedido.ultimaAtualizacao)}
                            </p>
                          </React.Fragment>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="card bg-c-blue order-card">
                  <div className="card-block">
                    <h6 className="m-b-20 text-center">
                      {pedidosAguardandoFaturamento.length}
                    </h6>

                    <p className="dashboard-text-status">
                      CONFERIDO AGUARDANDO FATURAMENTO
                    </p>
                    {(() => {
                      const ultimoPedido = this.getUltimoPedidoPorStatus(
                        pedidosAguardandoFaturamento
                      );
                      if (ultimoPedido) {
                        return (
                          <React.Fragment>
                            <p
                              style={{ fontSize: '0.7rem' }}
                              className="m-t-10"
                            >
                              Último Pedido: {ultimoPedido.numeroPedido}
                            </p>
                            <p style={{ fontSize: '0.7rem' }}>
                              Data:{' '}
                              {this.formatDate(ultimoPedido.ultimaAtualizacao)}
                            </p>
                          </React.Fragment>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="card bg-c-green order-card">
                  <div className="card-block">
                    <h6 className="m-b-20 text-center">
                      {pedidosFaturados.length}
                    </h6>

                    <p className="dashboard-text-status">
                      FATURADO AGUARDANDO EXPEDIÇÃO
                    </p>
                    {(() => {
                      const ultimoPedido = this.getUltimoPedidoPorStatus(
                        pedidosFaturados
                      );
                      if (ultimoPedido) {
                        return (
                          <React.Fragment>
                            <p
                              style={{ fontSize: '0.7rem' }}
                              className="m-t-10"
                            >
                              Último Pedido: {ultimoPedido.numeroPedido}
                            </p>
                            <p style={{ fontSize: '0.7rem' }}>
                              Data:{' '}
                              {this.formatDate(ultimoPedido.ultimaAtualizacao)}
                            </p>
                          </React.Fragment>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
            </div>

            <div className={'row w-100 px-5'}>
              <div className={'col'}>
                <SelectInput
                  className="w-100"
                  name="situacao"
                  id="situacao"
                  label="Situação"
                  placeholder="Selecione a situação"
                  options={objectsConstants.STATUS_PEDIDO}
                  value={this.state.situacao || ''}
                  onChange={(name, value) => {
                    this.setState({ situacao: value }, () => {
                      this.refTable.getWrappedInstance().updateTable();
                    });
                  }}
                  labelKey="label"
                  valueKey="value"
                  multi={false}
                  returnFullObject={false}
                  creatable={false}
                  required={false}
                />
              </div>
              <div className={'col'}>
                <label className="">Número Pedido</label>
                <InputFilter
                  type="number"
                  className={`form-control w-100`}
                  name={`situacao`}
                  placeholder=""
                  value={''}
                  service={(value) => {
                    this.setState({ numeroPedido: value }, () => {
                      this.refTable.getWrappedInstance().updateTable();
                    });
                  }}
                />
              </div>
              <div className={'col'}>
                <label className="">Cliente</label>
                <InputFilter
                  type="text"
                  className={`form-control w-100`}
                  name={`situacao`}
                  placeholder=""
                  value={''}
                  service={(value) => {
                    this.setState({ cliente: value }, () => {
                      this.refTable.getWrappedInstance().updateTable();
                    });
                  }}
                />
              </div>
              <div className={'col'}>
                <SelectInput
                  className="w-100"
                  name="statusAlcis"
                  id="statusAlcis"
                  label="Status WMS"
                  placeholder="Selecione a situação"
                  options={objectsConstants.STATUS_PEDIDO_ALCIS}
                  value={this.state.statusAlcis || ''}
                  onChange={(name, value) => {
                    this.setState({ statusAlcis: value }, () => {
                      this.refTable.getWrappedInstance().updateTable();
                    });
                  }}
                  labelKey="label"
                  valueKey="value"
                  multi={false}
                  returnFullObject={false}
                  creatable={false}
                  required={false}
                />
              </div>
              <div className={'col'}>
                <label className="">Data Hora da Coleta</label>
                <InputFilter
                  type="text"
                  className={`form-control w-100`}
                  name={`dataHoraColeta`}
                  placeholder=""
                  value={''}
                  service={(value) => {
                    this.setState({ dataHoraColeta: value }, () => {
                      this.refTable.getWrappedInstance().updateTable();
                    });
                  }}
                />
              </div>
            </div>
            <div className={'px-5'}>
              <Datatable
                service={pedidosService}
                filter={{
                  numeroPedido: this.state.numeroPedido,
                  situacao: this.state.situacao,
                  cliente: this.state.cliente,
                  statusAlcis: this.state.statusAlcis,
                  dashboard: true,
                }}
                onRowClick={(pedido) => {
                  this.toogle(pedido);
                }}
                defaultOrder={'nome'}
                defaultDirection={'asc'}
                defaultFilter={{
                  numeroPedido: this.state.numeroPedido,
                  dashboard: true,
                }}
                fields={fields}
                array={'pedidos'}
                ref={(form) => {
                  this.refTable = form;
                }}
              >
                {tableColumn}
              </Datatable>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;

  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  {
    forwardRef: true,
  }
)(Dashboard);
